module.exports = __webpack_public_path__ + "static/media/julianna.17454520.jpg";